import React from 'react'
import { Stack } from '@sureco/design-system'
import Text from '@hixme-ui/text'
import { BookOutlined } from '@ant-design/icons'
import { HrisSyncPayrollResponseDto } from './types'
import { PAYROLL_STATUS, PAYROLL_STATUS_LABELS } from './constants'
import dayjs from 'dayjs'
import { DownloadButton } from '../../components/DownloadButton'
import { Tooltip } from '@surecompanies/core_components'

export const columns = [
  {
    title: (
      <Stack direction="row" align="center" space={10}>
        <BookOutlined />
        <Text bold>Customer</Text>
      </Stack>
    ),
    dataIndex: 'customerName',
  },
  {
    title: 'Activity',
    dataIndex: 'activity',
    render: (activity: HrisSyncPayrollResponseDto['activity']) => {
      const { startTime, endTime, effectedEmployees } = activity
      const startDate = startTime ? dayjs(startTime).format('M/D/YYYY') : ''
      const endDate = endTime ? dayjs(endTime).format('M/D/YYYY') : ''

      const dateLabel = [startDate]
      if (startDate !== endDate) dateLabel.push(endDate)

      const employees =
        Number(effectedEmployees) === 1
          ? `(${effectedEmployees} record)`
          : `(${effectedEmployees} records)`

      if (effectedEmployees === undefined) {
        return `${dateLabel.join(' - ')}`
      }

      const label = `${dateLabel.join(' - ')} ${employees}`

      if (!activity.downloadableUrl) return label

      return (
        <DownloadButton url={activity.downloadableUrl}>{label}</DownloadButton>
      )
    },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    render: (status: HrisSyncPayrollResponseDto['status']) => {
      if (status.name !== PAYROLL_STATUS.ERROR) {
        return PAYROLL_STATUS_LABELS[status.name]
      }

      return (
        <Tooltip title={status.error}>
          <span style={{ cursor: 'pointer' }}>
            {PAYROLL_STATUS_LABELS[status.name]}
          </span>
        </Tooltip>
      )
    },
  },
]
